import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  ToastService,
  UmssConfirmDialogComponent,
  UmssFeedbackButtonComponent
} from '@umss/shared/ui';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    UmssConfirmDialogComponent,
    UmssFeedbackButtonComponent
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'facility';
  readonly feedbackUrl =
    'https://docs.google.com/forms/d/e/1FAIpQLSf4os-iW777wDoQt34MB7YjdiirGWPmTAIP5EaHp9EkXvgXyg/viewform?usp=publish-editor';

  constructor(
    private toastService: ToastService,
    private vcr: ViewContainerRef
  ) {}

  ngOnInit() {
    this.toastService.registerContainer(this.vcr);
  }
}
